function Logout() {
  return null;
}

export default Logout;
